// extracted by mini-css-extract-plugin
export default {"root":"AlertsWorkSupportList_root__cmhC4","root_nothing":"AlertsWorkSupportList_root_nothing__5XvsJ"};